// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router';
import { Base64 } from 'js-base64';
import environment from '../environment';
import Page from '../Page';

import type { User } from '../entities';

type Props = {
  name?: string;
  component: any;
  componentProps?: any;
  user: ?User;
  authenticated: ?boolean;
};

export const PrivateRoute = ({ component: Component, componentProps, user, authenticated, name, ...rest }: Props) => (
  <Route {...rest}
         render={props => {
           if (environment.env === 'local') {
             const Comp = <Component {...props} {...componentProps}/>;
             return !!name ? <Page name={name}>{Comp}</Page> : Comp;
           }
           const content = !!name ? <Page name={name}>
             <Component {...props} {...componentProps}/>
           </Page> : <Component {...props} {...componentProps}/>;
           let redirectString = "";
           if (props.location.pathname) {
             redirectString = props.location.pathname;
           }
           if (props.location.search) {
             redirectString += props.location.search;
           }
           if (props.location.hash) {
             redirectString += props.location.hash;
           }
           const redirect = Base64.encode(redirectString);
           return !!user && !!authenticated ? (content) :
             (<Redirect
               to={{
                 pathname: '/login',
                 search: `${redirect && `?redirect=${redirect}`}`,
                 state: { from: props.location },
               }}/>)
         }}
  />
);

PrivateRoute.propTypes = {
  name: PropTypes.string,
  component: PropTypes.func.isRequired,
  user: PropTypes.object,
  authenticated: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/router/PrivateRoute.jsx